import { createContext, useContext } from "react";

import { desktop } from "../desktop.ts";
import { ConnectionStore } from "./ConnectionStore.ts";
import { SetupStore } from "./SetupStore.ts";
import { UiStore } from "./UiStore.ts";
import { WorkerStore } from "./WorkerStore.ts";

/** All global state. Components get it with useStores(). */
export class RootStore {
    readonly workers = new WorkerStore();
    readonly connection = new ConnectionStore(this.workers);
    readonly ui = new UiStore();
    readonly setup = new SetupStore(desktop, this.connection);
}

export const StoreContext = createContext<RootStore | undefined>(undefined);

export function useStores(): RootStore {
    const stores = useContext(StoreContext);

    if (!stores) throw new Error("useStores() only works inside <StoreContext.Provider>.");

    return stores;
}
